import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider, useAuth } from "@clerk/clerk-react";
import { ConvexProviderWithClerk } from "convex/react-clerk";
import { ConvexReactClient } from "convex/react";
import { ThemeProvider } from "next-themes";
import AppRouter from "./router";
import "./index.css";

const CONVEX_URL = import.meta.env.BUN_PUBLIC_CONVEX_URL as string;
const CLERK_PUBLISHABLE_KEY = import.meta.env
    .BUN_PUBLIC_CLERK_PUBLISHABLE_KEY as string;

if (!CONVEX_URL) throw new Error("Missing BUN_PUBLIC_CONVEX_URL");
if (!CLERK_PUBLISHABLE_KEY)
    throw new Error("Missing BUN_PUBLIC_CLERK_PUBLISHABLE_KEY");

const convex = new ConvexReactClient(CONVEX_URL);

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <ThemeProvider
            attribute="data-theme"
            defaultTheme="system"
            enableSystem
            disableTransitionOnChange={false}
        >
            <ClerkProvider
                publishableKey={CLERK_PUBLISHABLE_KEY}
                afterSignOutUrl="/"
            >
                <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
                    <AppRouter />
                </ConvexProviderWithClerk>
            </ClerkProvider>
        </ThemeProvider>
    </React.StrictMode>,
);
